import { registerTextKey } from 'src/core/translatorMode';

/**
 * 12.10: a product text that still reads like a text key (TPL_…) was never resolved — the shop
 * shows nothing rather than the raw key. Other values pass unchanged.
 */
export function shownProductText<T extends string | null | undefined>(text: T): T | '' {
    return typeof text === 'string' && text.trim().startsWith('TPL_') ? '' : text;
}

/**
 * 12.8: the shop text as shown, registered with its text block key so the translator mode puts an
 * edit icon next to it (the key comes from the shop API: nameKey, descriptionKey, …).
 */
export function productText<T extends string | null | undefined>(text: T, key?: string | null): T | '' {
    const shown = shownProductText(text);
    registerTextKey(shown, key);
    return shown;
}
